import { BaseController } from "../../../../shared/basecontroller.controller";
import AvatarFormModel from './model/form.model.js';
import EVENTS from '@shared/events';

class AvatarController extends BaseController {
  constructor(HttpService, AppService, SessionService, CustomerApiService, $sce, ProfileStore, $translate) {
    'ngInject';

    super(AppService);

    this.HttpService = HttpService;
    this.SessionService = SessionService;
    this.$translate = $translate;
    this.ProfileStore = ProfileStore;
    this.CustomerApiService = CustomerApiService;
    this.$sce = $sce;
    this.currentAvatar = null;
    this.image = null;

    this.avatars = [
      'avatar-man1',
      'avatar-man2',
      'avatar-man3',
      'avatar-woman1',
      'avatar-woman2',
    ];
  }

  $onInit() {
    this.form = new AvatarFormModel();

    this.ProfileStore.getProfile().then((profile) => {
      this.currentAvatar = profile.avatar;

      this.loadAvatar();
    });
  }

  onAvatarChange(avatar) {
    this.form.avatar = avatar;

    this.submit();
  }

  submit() {
    this.CustomerApiService.updateAvatar(this.form.toPayload())
      .then((response) => {
        this.currentAvatar = response;
        this.SessionService.set('selectedAvatar', response.selected);
        this.SessionService.set('uploadedAvatar', response.uploaded);

        this.form.reset();
      })
      .catch((errors) => {
        this.form.setFormErrors(errors);
      })
    ;
  }

  loadAvatar() {
    if (this.currentAvatar && this.currentAvatar.uploaded) {
      this.CustomerApiService.getAvatar(this.currentAvatar.uploaded).then((fileUri) => {
        this.HttpService.$http.get(fileUri, {responseType: 'arraybuffer'}).then((s3data) => {
          const fileObj = new Blob([s3data], {type: 'application/binary'});
          this.image = this.$sce.trustAsResourceUrl(URL.createObjectURL(fileObj));
        });
      });
    }    
  }
}

export default AvatarController;


// WEBPACK FOOTER //
// ./client/app/pages/settings/component/avatar/avatar.controller.js